import { ReactComponent as GoldMedal } from "@assets/draws/gold-medal.svg";
import { ReactComponent as SilverMedal } from "@assets/draws/silver-medal.svg";
import { ReactComponent as BronzeMedal } from "@assets/draws/bronze-medal.svg";

export const MEDAL_COLORS = ["#F5C842", "#B0B0B0", "#CD7F4B"];
export const MEDAL_COMPONENTS = [GoldMedal, SilverMedal, BronzeMedal];
